import _isNaN from 'lodash/isNaN';

function validateLength(length, minLength, maxLength) {
  if (_isNaN(length)) {
    return 'Invalid Length';
  }
  if (length < minLength) {
    return `Length must be greater than ${minLength - 1}`;
  }
  if (length > maxLength) {
    return `Length must be less than ${maxLength + 1}`;
  }
  return null;
}

export default validateLength;
